// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnitNotableConcepts_notable-concepts-wrapper__bbMBc {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
}
@media only screen and (max-width: 900px) {
  .UnitNotableConcepts_notable-concepts-wrapper__bbMBc {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/UnitDetail/Components/UnitNotableConcepts/UnitNotableConcepts.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;AACJ;AACI;EANJ;IAOQ,aAAA;EAEN;AACF","sourcesContent":[".notable-concepts-wrapper {\n    background: #fff;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    padding: 20px;\n\n    @media only screen and (max-width: 900px) {\n        padding: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notable-concepts-wrapper": `UnitNotableConcepts_notable-concepts-wrapper__bbMBc`
};
export default ___CSS_LOADER_EXPORT___;
